import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const PageHero = ({ title, highlight, subtitle, crumb }) => {
  return (
    <section className="relative pt-36 pb-16 md:pt-44 md:pb-20 overflow-hidden grid-bg">
      <div className="glow-blob w-96 h-96 bg-[#00ff87] -top-24 left-1/4" />
      <div className="glow-blob w-72 h-72 bg-[#00e5ff] top-10 right-10" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
        <nav className="flex items-center justify-center gap-2 text-sm text-gray-400 mb-5">
          <Link to="/" className="hover:text-[#00ff87]">Home</Link>
          <ChevronRight size={15} />
          <span className="text-[#00ff87]">{crumb}</span>
        </nav>
        <h1 className="font-display text-4xl sm:text-5xl md:text-6xl font-extrabold text-white leading-tight">
          {title} {highlight && <span className="neon-green text-glow-green">{highlight}</span>}
        </h1>
        {subtitle && (
          <p className="mt-5 text-gray-300 text-lg max-w-2xl mx-auto leading-relaxed">{subtitle}</p>
        )}
      </div>
    </section>
  );
};

export default PageHero;
